import React, { useEffect, useState } from 'react'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import TimelineItem from '@mui/lab/TimelineItem'
import TimelineSeparator from '@mui/lab/TimelineSeparator'
import TimelineConnector from '@mui/lab/TimelineConnector'
import TimelineDot from '@mui/lab/TimelineDot'
import Typography from '@mui/material/Typography'
import { formatLocal, formatUTC } from 'utils/date'
import Pagination from '@mui/material/Pagination'

import { translate } from 'locales'

import { CardDate, Loading } from 'components'
import noData from 'assets/images/no-data.svg'
import { useUser } from 'context/user/user.context'
import { parseISO, differenceInMinutes } from 'date-fns'
import TimeLineResumePsicology from './TimeLineResumePsicology'

import { findAllMedicalRecordsPsico } from './services'

import * as S from './styles'
import * as N from '../New/styles'
import {
  Timeline,
  TimelineContent,
  TimelineOppositeContent,
  AccordionHeadingDivResponsive,
} from '../timelineStyles'

interface IResume {
  userUUID: string
}

const Psico: React.FunctionComponent<IResume> = ({ userUUID }) => {
  const { userData } = useUser()

  const [records, setRecords] = useState<any>({})
  const [loading, setLoading] = useState(true)

  const [totalPages, setTotalPages] = useState(0)
  const [page, setPage] = useState(1)

  useEffect(() => {
    const specialties = userData?.specialties

    const specialty =
      specialties &&
      specialties.filter((item: any) => item.slug === 'psicologo')[0]

    if (specialty) {
      findAllMedicalRecordsPsico(
        userUUID,
        specialty.id,
        setRecords,
        setLoading,
        page,
        setTotalPages
      )
    }
  }, [userData, page])

  const timeConsultation = (e: any, t: any) => {
    const startConsultation = parseISO(e)
    const endConsultation = parseISO(t)

    const consultationDuration = differenceInMinutes(
      endConsultation,
      startConsultation
    )
    return consultationDuration
  }

  return (
    <>
      {loading && <Loading title={translate('medicalRecord.loadingData')} />}
      <Timeline position="right">
        {records.medicalRecordsPsico &&
          Object.keys(records.medicalRecordsPsico).length === 0 && (
            <N.NoData>
              <img
                src={noData}
                alt="Icone simbolizando que não existe prontuarios a serem exibidas"
              />
              <span>{translate('medicalRecord.notMedicalRecord')}</span>
            </N.NoData>
          )}

        {records.medicalRecordsPsico &&
          Object.keys(records.medicalRecordsPsico).map((item) => (
            <TimelineItem key={item}>
              <TimelineOppositeContent>
                <CardDate
                  day={formatUTC(item, 'dd')}
                  month={formatUTC(item, 'MMM')}
                  year={formatUTC(item, 'yyyy')}
                />
              </TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineDot />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                {records.medicalRecordsPsico[item].map((i: any) => (
                  <Accordion key={i.id}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id={i.id}
                    >
                      <AccordionHeadingDivResponsive
                        style={{
                          marginTop: 0,
                          display: 'flex',
                          flex: 1,
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                        <Typography>
                          {`${translate('medicalRecord.by')} Dr(a). ${
                            i.scheduling?.doctor?.name
                          }`}

                          <Typography>
                            {`${translate('schedule.scheduleDate')}: ${formatLocal(i.scheduling.from_date_time, 'dd/MM/yyyy')}`}
                          </Typography>
                        </Typography>
                      </AccordionHeadingDivResponsive>
                      <div>
                        <Typography>
                          {timeConsultation(
                            i.scheduling?.from_date_time,
                            i.scheduling?.to_date_time
                          )}{' '}
                          min {`(${i.scheduling?.specialty_name})`}
                        </Typography>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails style={{ display: 'block', padding: 0 }}>
                      <TimeLineResumePsicology
                        history={i}
                        setLoading={setLoading}
                      />
                    </AccordionDetails>
                  </Accordion>
                ))}
              </TimelineContent>
            </TimelineItem>
          ))}
        <S.ContentPagination>
          {totalPages > 1 && (
            <Pagination
              count={totalPages}
              onChange={(event: React.ChangeEvent<unknown>, value: number) => {
                setPage(value)
              }}
            />
          )}
        </S.ContentPagination>
      </Timeline>
    </>
  )
}

export default Psico
